import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0f9015e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "measurement-info" }
const _hoisted_2 = { class: "measurement-info-label" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  ( ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_6 = { class: "measurement-info-value" }

import { computed } from 'vue';
import { NText } from 'naive-ui';


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    target: null,
    value: null
  },
  setup(__props: any) {

const props = __props as { label: string; target?: number; value: number }



const percentage = computed<null | number>(() => {
	if (typeof props.target === 'number' && props.target !== 0) {
		return props.value / (props.target / 100);
	}

	return null;
});

const valueString = computed<string>(() => {
	const result = [
		new Intl.NumberFormat('cs-CZ', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(props.value),
	];
	if (typeof props.target === 'number' && props.target !== 0) {
		result.push(
			new Intl.NumberFormat('cs-CZ', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			}).format(props.target),
		);
	}

	return result.join(' / ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.label), 1),
      (_unref(percentage))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(NText), {
              type: _unref(percentage) >= 100 ? 'success' : 'error'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(new Intl.NumberFormat('cs-CZ', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(_unref(percentage))) + "% ", 1)
              ]),
              _: 1
            }, 8, ["type"]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(valueString)), 1)
  ]))
}
}

})